module.exports = __webpack_public_path__ + "img/reservation.b07e4d54.png";